/*
  created by Rija
  added on 2/1/2021
  @desc meter main page to swtich between different options
*/

import React, { Component, createRef } from 'react';
import { Route } from 'react-router-dom';
import { ButtonGroup, Button } from 'react-bootstrap';
import { ColorButton, FiltersContainer, HeadingContainer, SearchContainer } from '../../../../neoverv';
import Autoload from '../../../../neoverv/Autoload';
import { withRouter } from 'react-router-dom';
import MessagingEditor from './MessagingEditor';
import { IconButton, TableContainer, Tooltip } from '@material-ui/core';
import { Group, Input, Popover, Select, Stack, Text } from '@mantine/core';
import Up from '../../../../assets/images/module/general/SelectArrowUp.svg';
import Down from '../../../../assets/images/module/general/SelectArrowDown.svg';
import PrintIconBlue from '../../../../assets/images/module/general/PrintIconBlue.svg';
import PrintIconWhite from '../../../../assets/images/module/general/PrintIconWhite.svg';
import MessagingEditorMantine from './MessagingEditorMantine';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import moment from 'moment';
import ReplyIcon from '@material-ui/icons/Reply';
import ReplyAllIcon from '@material-ui/icons/ReplyAll';
import breadcrumbsContent from '../../../../../src/assets/breadcrumbs.json';
import HelpLogo from '../../../../assets/images/module/general/book.svg';
import TourIcon from '../../../../assets/images/module/general/TourIcon.svg';
import BlueTick from '../../../../assets/images/module/general/BlueTick.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import YellowTick from '../../../../assets/images/module/general/YellowTick.svg';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import RightArrowPartner from '../../../../assets/images/module/general/RightArrowPartner.svg';
import ExplanationMarkIcon from '../../../../assets/images/module/general/ExplanationMarkIcon.svg';
import CrossIcon from '../../../../assets/images/module/general/CrossIcon.svg';
import { connect } from 'react-redux';
import MessagePreviewModal from '../../../../neoverv/components/Module/General/CustomModal/MessagePreviewModal';
import SelectMessageRecipientToPrint from '../../../../neoverv/components/Module/General/CustomModal/SelectMessageRecipientToPrintModal';
import MessagePostviewModal from '../../../../neoverv/components/Module/General/CustomModal/MessagePostviewModal';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import BulkDownloadForMessageModal from '../../../../neoverv/components/Module/General/CustomModal/BulkDownloadForMessageModal';
import DownloadIcon from '../../../../assets/images/module/general/DownloadIconBlue.svg';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { loader, checkProperty, checkEnvironment, errorHandlingForPDF, downloadDocument } = Autoload.MainHelper;

const MOBILE_SIZE = 992;

class MessageDetail extends Component {

  state={
    openRecipientStatus: null,
    openPreviewModal: false,
    openSelectMessageRecipientToPrintModal: false,
    selectedRecipient: null,
    selectedMessageErrorPopover: null,
    scrollX: 0,
    maxScrollX: 400,
    isOverflowing: false,
    openBulkMessageDownloadModal: false,
    selectedMessageForBulkDownload: null
  }

  constructor(props) {
    super(props);
    this.divRef = createRef();
    const html = '<h1 style="text-align:center;">Hellohousing Message</h1><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p>';
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const content = EditorState.createWithContent(contentState);
      console.log('content: ', contentBlock);
      this.state = {
        ...this.state,
        content,
        html,
        isMobile: window.innerWidth <= MOBILE_SIZE,
        //message: props.location.state.message
      };
    }
  }

  componentDidMount(){
    window.addEventListener('resize', this.handleResize);
    const scrollableDiv = window.document.getElementById('message-recipients-list-container')
    const originalWidth = scrollableDiv.scrollWidth;
    this.setState({maxScrollX: originalWidth});

    this.checkOverflow();
    window.addEventListener("resize", this.checkOverflow);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener("resize", this.checkOverflow);
  }

  checkOverflow = () => {
    if (this.divRef.current) {
      this.setState({
        isOverflowing: this.divRef.current.scrollWidth > this.divRef.current.clientWidth,
      });
    }
  };

  handleResize = () => {
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  downloadPdfFromServer=()=>{
    console.log('downloadPdfFromServer:');
    const data = new FormData();
    let html = document.getElementById('message-body');
    let doc = document.implementation.createHTMLDocument("New Document");
    try {
      doc.body.appendChild(html);
      const blob = new Blob([doc.documentElement.innerHTML], {
        type: 'text/html'
       });
      
      const fileName = `messagingTemplate2-${this.props.propertySelected.name}-${new Date().valueOf()}}`;
      let file = new File([blob], fileName);
      file.originalname = fileName;
      console.log('downloadPdfFromServer: ', file);
      data.append('file', file);
      let url = `https://${checkEnvironment()}.hellohousing.de/api/reporting-api/pdf`;
      fetch(url,
        {
          method: 'POST',
          body: data,
          headers: {
            Authorization: Autoload.Utils.getAuthToken(),
          }
        }).then((response)=> {
          if(response.status === 200){
            response.blob()
            .then(data => {
              //download progress
              var a = document.createElement("a");
              document.body.appendChild(a);
              let url = window.URL.createObjectURL(data);
              a.href = url;
              a.download = 'test.pdf';
              a.click();
              window.URL.revokeObjectURL(url);
            }) 
          }else{
            errorHandlingForPDF(response, this.props.profileData, url);
          }
        });
    } catch (e) {
      console.log('downloadPdfFromServer: ', e);
    }
  }

  replaceValuesWithPlaceHolders=(html)=>{
    let newHtml= html;

    newHtml= newHtml.replaceAll('{{TENANT_OCCUPATION_BILLING_PERIOD}}', '<a href="#" target="_self">Abrechnungszeitraum</a>');
    newHtml= newHtml.replaceAll('{{BILLING_PERIOD}}', '<a href="#" target="_self">Abrechnungszeitraum</a>');
    newHtml= newHtml.replaceAll('{{TOTAL_ALLOCATED_UTILITY_COSTS}}', '<a href="#" target="_self">Betriebskosten</a>');
    newHtml= newHtml.replaceAll('{{BILLING_STATEMENT_BALANCE}}', '<a href="#" target="_self">Guthaben / Nachzahlung</a>');
    newHtml= newHtml.replaceAll('{{RECIPIENT_NAME}}', '<a href="#" target="_self">Empfänger</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_UNIT_NAME}}', '<a href="#" target="_self">Mieteinheit</a>');
    newHtml= newHtml.replaceAll('{{PROPERTY_STREET}}, {{PROPERTY_ZIPCODE}} {{PROPERTY_CITY}}', '<a href="#" target="_self">Objektadresse</a>');
    newHtml= newHtml.replaceAll('{{TOTAL_ADVANCE_PAYMENTS}}', '<a href="#" target="_self">Vorauszahlungen</a>');

    newHtml= newHtml.replaceAll(`https://${window.location.href.includes('app') ? 'app' : 'dev'}.hellohousing-mieterportal.de/signup?{{SIGNUP_CODE}}`, '<a href="#" target="_self">Zugangslink</a>');

    //new
    newHtml= newHtml.replaceAll('{{TENANT_NAME}}', '<a href="#" target="_self">Mieter</a>');
    newHtml= newHtml.replaceAll('{{USER_FIRST_NAME}} {{USER_LAST_NAME}}', '<a href="#" target="_self">Absender</a>');
    newHtml= newHtml.replaceAll('{{TENANT_MOVE_OUT_DATE}}', '<a href="#" target="_self">Auszugsdatum</a>');
    newHtml= newHtml.replaceAll('{{TENANT_MOVE_IN_DATE}}', '<a href="#" target="_self">Einzugsdatum</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_RECEIVED_RENT}}', '<a href="#" target="_self">erhaltene Miete</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_EXPECTED_RENT_TOTAL}}', '<a href="#" target="_self">gesamte ausstehende Miete</a>');
    newHtml= newHtml.replaceAll('{{COLD_RENT}}', '<a href="#" target="_self">Kaltmiete</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_MONTH}}', '<a href="#" target="_self">Mietmonat</a>');
    newHtml= newHtml.replaceAll('{{ACCOUNT_COMPANY_NAME}}', '<a href="#" target="_self">Vermieter</a>');
    newHtml= newHtml.replaceAll('{{RENT_PRE_PAYMENTS}}', '<a href="#" target="_self">Vorauszahlung</a>');
    newHtml= newHtml.replaceAll('{{WARM_RENT}}', '<a href="#" target="_self">Warmmiete</a>');

    newHtml= newHtml.replaceAll(`https://${window.location.href.includes('app') ? 'app' : 'dev'}.hellohousing-mieterportal.de/signup?{{SIGNUP_CODE}}`, '<a href="#" target="_self">Zugangslink</a>');
    newHtml= newHtml.replaceAll('{{PROPERTY_OWNER_NAME}}', '<a href="#" target="_self">Eigentümer</a>');

    return newHtml;
  }

  renderReplyAndForwardButton=()=>{
    const {message} = this.props.location.state;
    const {selectedTenantId} = this.props;
    return (
      <Group wrap="nowrap">
        <div>
          <span style={{color: 'rgb(69, 69, 118)', fontSize: '14px', fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Alle herunterladen (PDF):</span>
          <Tooltip title={message?.recipients?.length === 1 ?  "Nachricht als PDF herunterladen" : "Alle Empfängernachrichten als PDF herunterladen"} >
            <IconButton 
            aria-label="filter list"
            onClick={()=> message?.recipients?.length === 1 ? downloadDocument(message?.recipients[0], message) : this.setState({openBulkMessageDownloadModal: true, selectedMessageForBulkDownload: message})}
              style={{
                background: 'white', 
                border: '1px solid #DADAE5', 
                boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
                padding: '5px',
                marginLeft: '8px',
              }}>
              <img
              src={DownloadIcon} 
              style={{
                width: '15px',
                height: '15px',
              }}/>
            </IconButton>
          </Tooltip>
        </div>
        <div>
          <span style={{color: 'rgb(69, 69, 118)', fontSize: '14px', fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Allen antworten:</span>
          <Tooltip title="Allen Empfängern antworten" >
            <IconButton 
            aria-label="filter list"
            onClick={()=> this.props.history.push('/messaging/newMessage', {message: {
              ...message,
              id: null,
              utilityBillingId: null,
              subject: this.replaceValuesWithPlaceHolders(message.subject),
              body: null,
              }, 
              recipients: message.recipients,
              replyAll: true,
              previousUrl: selectedTenantId ? `/user/tenant/information?tenantId=${selectedTenantId}` : null
            })}
            style={{
              background: 'white', 
              border: '1px solid #DADAE5', 
              boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
              padding: '5px',
              marginLeft: '8px',
              }}>
              <ReplyAllIcon 
              style={{
                  color: '#5655FE', 
                  width: '15px',
                  height: '15px'
              }}
              />
            </IconButton>
          </Tooltip>
        </div>
        
        {!message.utilityBillingId &&
        <div>
          <span style={{color: 'rgb(69, 69, 118)', fontSize: '14px', fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Weiterleiten:</span>
          <Tooltip title="Nachricht an weitere Empfänger weiterleiten" >
            <IconButton 
            aria-label="filter list" 
            onClick={()=> this.props.history.push('/messaging/newMessage', {
                message: {
                ...message,
                id: null,
                recipients: [],
                body: this.replaceValuesWithPlaceHolders(message.body),
                subject: this.replaceValuesWithPlaceHolders(message.subject)
                }, 
                recipients: null,
                forward: true,
                previousUrl: selectedTenantId ? `/user/tenant/information?tenantId=${selectedTenantId}` : null
            })}
            style={{
              background: 'white', 
              border: '1px solid #DADAE5', 
              boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
              padding: '5px',
              marginLeft: '8px',
              }}>
              {/* <img
              src={ReplyIcon} 
              style={{
                width: '15px',
                height: '15px',
                }}/> */}
              <ReplyIcon 
              className='forward-icon'
              style={{
                  color: '#5655FE', 
                  width: '15px',
                  height: '15px'
              }}
              />
            </IconButton>
          </Tooltip>
        </div>}
      </Group>
    )
  }

  renderMessageRecipients=()=>{
    const {message} = this.props.location.state;
    const {openRecipientStatus} = this.state;
    const {selectedTenantId} = this.props;
    return (
      message && message.recipients.sort((a,b)=> {
        if(selectedTenantId){
          if (a.tenantId === selectedTenantId) return -1;
          if (b.tenantId === selectedTenantId) return 1;
        }
        return a.name.localeCompare(b.name);
      }).map((recipient, index)=> 
      recipient.name &&
      <Popover
  opened={openRecipientStatus === recipient.id}
  position="top"
  withArrow
  transitionProps={{ duration: openRecipientStatus === null ? 1000 : 500 }} // 1. Grouped transition props
>
  {/* 2. Target Wrapper */}
  <Popover.Target>
    <Group 
      onClick={() => {
        const setOpenPreviewModal = () => this.setState({ openPreviewModal: true, selectedRecipient: recipient.id });
        if (message.status !== 'Failed') {
          if (selectedTenantId) {
            if (selectedTenantId === recipient.tenantId) {
              setOpenPreviewModal();
            }
          } else {
            setOpenPreviewModal();
          }
        }
      }} 
      onMouseEnter={() => {
        const setOpenRecipientStatus = () => this.setState({ openRecipientStatus: recipient.id });
        if (selectedTenantId) {
          if (selectedTenantId === recipient.tenantId) {
            setOpenRecipientStatus();
          }
        } else {
          setOpenRecipientStatus();
        }
      }} 
      onMouseLeave={() => this.setState({ openRecipientStatus: null })}
      gap={5} 
      className="message-card-ten-cards" 
      style={{
        height: '20.6px', 
        maxHeight: '20.6px', 
        background: 'white', 
        paddingRight: message.status !== 'Draft' ? '3px' : '10px', 
        overflowX: 'scroll', 
        opacity: selectedTenantId ? selectedTenantId === recipient.tenantId ? 1 : 0.5 : 1, 
        cursor: selectedTenantId ? selectedTenantId === recipient.tenantId ? 'pointer' : 'not-allowed' : 'pointer'
      }}
      wrap="nowrap"
    >
      <Group style={{ background: '#454576', width: '18px', minWidth: '18px', borderRadius: '120px' }} justify="center" align="center">
        <span style={{ textTransform: 'capitalize', color: 'white' }}>{recipient.name[0]}</span>
      </Group>
      <span style={{ whiteSpace: 'nowrap' }}>{recipient.name}</span>
      {message.status !== 'Draft' && (
        <Group>
          <img 
            style={{ minWidth: '16px' }} 
            src={(message.status === 'Failed' || (recipient.isPostEnabled && (recipient.postalStatus === 'Failed' || recipient.postalStatus === 'Verarbeitungsfehler')) || (recipient.isEmailEnabled && recipient.emailStatus === 'Failed')) ? ExplanationMarkIcon : (recipient.isPostEnabled && recipient.postalStatus === 'Publish') ? YellowTick : GreenTick}
            alt="Status Icon"
          />
        </Group>
      )}
    </Group>
  </Popover.Target>

  {/* 3. Dropdown Wrapper */}
  <Popover.Dropdown p="xs">
    {message.status === 'Failed' ? (
      <span style={{ fontSize: '12px', fontWeight: '400' }}>
        Es ist ein Fehler bei der Übermittlung der Nachricht aufgetreten. Die Nachricht konnte nicht gesendet werden. Wenden Sie sich bei Fragen an den Kundenservice.
      </span>
    ) : (
      <Stack 
        gap={10} 
        style={{ fontSize: '12px', fontWeight: '400' }}
        onMouseEnter={() => this.setState({ openRecipientStatus: recipient.id })}
        onMouseLeave={() => this.setState({ openRecipientStatus: null })}
      >
        <Stack gap={10}>
          {recipient.isPostEnabled && (
            <Group gap={5}>
              <span>Briefversand:</span>
              {recipient.postalStatus === 'Publish' ? <img src={YellowTick} alt="status" />
              : recipient.postalStatus === 'Sent' ? <img src={GreenTick} alt="status" />
              : recipient.postalStatus === 'Verarbeitungsfehler' ? <img src={RedCross} alt="status" />
              : recipient.postalStatus === 'Failed' ? <img src={RedCross} alt="status" />
              : recipient.postalStatus === 'Draft' && <img src={YellowTick} alt="status" />}
              {recipient.postalStatus === 'Failed' ? <span>Übertragungsfehler</span> : ''}
              {recipient.postalStatusMessage && <span>{recipient.postalStatusMessage}</span>}
            </Group>
          )}
          {recipient.isEmailEnabled && (
            <Group gap={5}>
              <span>Email-Versand:</span>
              {recipient.emailStatus === 'Publish' ? <img src={YellowTick} alt="status" />
              : recipient.emailStatus === 'Sent' ? <img src={GreenTick} alt="status" />
              : recipient.emailStatus === 'Error' ? <img src={RedCross} alt="status" />
              : recipient.emailStatus === 'Failed' ? <img src={RedCross} alt="status" />
              : recipient.emailStatus === 'Draft' && <img src={YellowTick} alt="status" />}
              {recipient.emailStatus === 'Failed' ? <span>Übertragungsfehler</span> : recipient.emailStatus === 'Sent' ? 'Nachricht übermittelt' : ''}
            </Group>
          )}
          {recipient.isHiddenForTenantPortal === false && (
            <Group gap={5}>
              <span>Mieterportal:</span>
              <img src={GreenTick} alt="status" />
              <span>Nachricht übermittelt</span>
            </Group>
          )}
        </Stack>
        <Group onClick={() => this.setState({ openPreviewModal: true, selectedRecipient: recipient.id })}>
          <span style={{ color: '#5555FF', cursor: 'pointer' }}>
            Empfängernachricht anzeigen <img src={RightArrowPartner} style={{ width: '12px', marginLeft: '2px' }} alt="arrow" />
          </span>
        </Group>
      </Stack>
    )}
  </Popover.Dropdown>
</Popover>
      
      )
    )
  }

  renderMessageRecipientsContainer=()=>{
    const {scrollX, maxScrollX, isMobile, isOverflowing} = this.state;
    const {message} = this.props.location.state;
    return (
    <Group gap={10} wrap="nowrap" justify="space-between">
      {(message.recipients.length > 1 && isOverflowing) &&
      <Group 
        onClick={()=> {
          let container = window.document.getElementById('message-recipients-list-container');
          if(scrollX >= 100){
            container.scrollTo({left: scrollX-100, top: 0, behavior: 'smooth'});
            this.setState({scrollX: scrollX-100});
          }
        }}
        onDoubleClick={()=>{
          let container = window.document.getElementById('message-recipients-list-container');
          container.scrollTo({left: 0, top: 0, behavior: 'smooth'});
          this.setState({scrollX: 0});
        }}
        style={{opacity: scrollX <= 0 ? 0.5 : 1, marginBottom: 0, padding: 0}}
        className={'chevron-button'}
        >
          <ChevronLeftIcon
          style={{
            color: '#000'
          }}
          />
      </Group>}
      <Group id='message-recipients-list-container' ref={this.divRef} className='messages-list-recipients' style={{maxWidth: !isMobile && '620px', overflowX: 'scroll', width: isMobile && '100%'}} wrap="nowrap">
        {this.renderMessageRecipients()}
      </Group>
      {(message.recipients.length > 1 && isOverflowing) &&
      <Group 
      className={'chevron-button'}
      style={{opacity: scrollX >= maxScrollX ? 0.5 : 1, marginBottom: 0, padding: 0}} 
      onClick={()=> {
      let container = window.document.getElementById('message-recipients-list-container');
      if(scrollX < maxScrollX){
      container.scrollTo({left: scrollX+100, top: 0, behavior: 'smooth'});
      this.setState({scrollX: scrollX+100});
      }
      }}
      onDoubleClick={()=>{
      let container = window.document.getElementById('message-recipients-list-container');
      container.scrollTo({left: maxScrollX, top: 0, behavior: 'smooth'});
      this.setState({scrollX: maxScrollX});
      }}>
      <ChevronRightIcon
      style={{
      color: '#000'
      }}
      />
      </Group>}
    </Group>
    )
  }

  renderCross=()=>{
    const {currentMessageData, selectedTenantId} = this.props;
    return(
      <img src={CrossIcon} alt='cross-icon' id={'utility-message-draft-3'} style={{cursor: 'pointer'}} onClick={()=>{
        loader(true);
        setTimeout(() => {
          loader(false);
          if(currentMessageData?.templateType === 'RentalPayment'){
            this.props.history.push('/user/rentIncomeTracking');
          }else if(currentMessageData?.templateType === 'TenantSignUp'){
            this.props.history.push('/tenantPortal');
          }else if(selectedTenantId){
            this.changePage('messages', null);
          }else{
            this.props.history.push('/messaging/messages');
          }
          //this.props.history.push(window.location.href.includes('/newMessage') ? '/messaging/messages' : window.location.href.includes('/messageDetail') && '/messaging/messages');
        }, 600);
      }}/>
    )
  }

  changePage(route, data) {
    if(route.includes('information')){
      let url = route+'?tenantId='+ this.state.tenantId;
      this.props.history.push(url, {
        ...data,
        unitId: checkProperty(this.props.history.location.state, 'unitId')
      });
    }else{
      this.props.history.push(route + '?tenant=' + Autoload.Utils.getUrlParameterByName('tenant'), {
        ...data,
        unitId: checkProperty(this.props.history.location.state, 'unitId')
      });
    }
  }

  render() {
    const {message} = this.props.location.state;
    const {openRecipientStatus, openPreviewModal, openSelectMessageRecipientToPrintModal, selectedRecipient, isMobile, selectedMessageErrorPopover, scrollX, maxScrollX, openBulkMessageDownloadModal, selectedMessageForBulkDownload} = this.state;
    const {accountData, selectedTenantId} = this.props;
    console.log('message: ', message);
    console.log('isMobile: ', isMobile, window.innerWidth <= MOBILE_SIZE);
    console.log('scrollX: ', scrollX);
    return (
      <div className="messages-list-screen">
        <Group>
            {(isMobile && (window.location.href.includes('/newMessage') || window.location.href.includes('/messageDetail'))) && this.renderCross()}
            {!selectedTenantId &&
            <div style={{display: 'flex'}}>
            {breadcrumbsContent.map((item)=> item.area === '/messaging' && 
            item.breadcrumbs.map((breadcrumb)=>
            breadcrumb.type === 'tour' ? breadcrumb.condition === 'rental_unit_created' && breadcrumb.view === 'desktop' &&
            <div style={{display: 'flex', width: 'auto', alignItems: 'center', cursor: 'pointer', marginRight: '22px'}} onClick={()=> window.Intercom('startTour', breadcrumb.id)}>
                <img src={TourIcon} />
                <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px'}}>{breadcrumb.label}</span>
            </div>
            :
            breadcrumb.view === 'desktop' &&
            <div style={{display: 'flex', width: 'auto', alignItems: 'center', cursor: 'pointer', marginRight: '22px'}} onClick={()=> window.Intercom('showArticle', breadcrumb.id)}>
                <img src={HelpLogo} />
                <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px'}}>{breadcrumb.label}</span>
            </div>
            ))}
            </div>}
        </Group>
        {!selectedTenantId && <div className="divider"></div>}
        <div>
          <Stack>
            <Group style={{justifyContent: 'space-between', alignItems: 'flex-end'}} wrap="nowrap">
                <Stack style={{width: '100%'}} id={'main-container-for-message-info'} gap={selectedTenantId && 'xl'}>
                    <Group justify={(isMobile || selectedTenantId) && 'space-between'}>
                      <Group gap={10}>
                        <Group className={message.status === 'Failed' ? 'partner-list-row-tag-badge-failed' : 'partner-list-row-tag-badge'} gap={5} style={{paddingRight: message.recipients.find((recipient)=> recipient.postalStatus === 'Failed' || recipient.emailStatus === 'Failed') !== undefined ? '2px' : '6px'}}>
                          {message.status === 'Failed' ?
                          <span>Fehler</span>
                          :
                          message.status === 'Draft' ?
                          <span>Entwurf</span>
                          :
                          <span>Gesendet</span>}
                          {message.recipients.find((recipient)=> recipient.postalStatus === 'Failed' || recipient.emailStatus === 'Failed') !== undefined &&
                          <Popover
  opened={selectedMessageErrorPopover === message.id}
  // 1. Combined position and placement
  position="top-end"
  withArrow
>
  {/* 2. Target Wrapper */}
  <Popover.Target>
    <Group 
      onMouseEnter={() => this.setState({ selectedMessageErrorPopover: message.id })} 
      onMouseLeave={() => this.setState({ selectedMessageErrorPopover: null })}
    >
      <img src={ExplanationMarkIcon} alt="Error" />
    </Group>
  </Popover.Target>

  {/* 3. Dropdown Wrapper */}
  <Popover.Dropdown p="xs">
    {message.status === 'Failed' ? (
      <span style={{ fontSize: '12px', fontWeight: '400' }}>
        Es ist ein Fehler bei der Übermittlung der Nachricht aufgetreten. Die Nachricht konnte nicht gesendet werden. Wenden Sie sich bei Fragen an den Kundenservice.
      </span>
    ) : (
      <span style={{ fontSize: '12px', fontWeight: '400' }}>
        Es ist ein Übertragungsfehler aufgetreten. Bitte prüfen Sie den Versandstatus und wenden Sie sich bei Fragen an den Kundenservice.
      </span>
    )}
  </Popover.Dropdown>
</Popover>}
                        </Group>
                        <span className='message-card-time'>{moment(message.updatedOn).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') ? `heute (${moment(moment.utc(message.updatedOn).toDate()).local().format('LT')} Uhr)` : `${moment(message.updatedOn).format('DD.MM.YYYY')} (${moment(moment.utc(message.updatedOn).toDate()).local().format('LT')} Uhr)`}</span>
                      </Group>
                      <Group gap={10}>
                        {isMobile && this.renderReplyAndForwardButton()}
                        {selectedTenantId && 
                        <Group style={{width: '27px'}} justify='center'>
                          {this.renderCross()}
                        </Group>}
                      </Group>
                    </Group>
                    {isMobile && this.renderMessageRecipientsContainer()}
                    <Group justify="space-between" align={'flex-end'}>
                      <Group gap={10} style={{height: '24px', flex: '1 1 auto', overflowY: 'auto', overflowX: 'hidden', marginTop: !isMobile ? '16px' : '0px'}} wrap="nowrap">
                          <span style={{whiteSpace: 'nowrap'}} className={'message-card-title'} dangerouslySetInnerHTML={{__html: this.replaceValuesWithPlaceHolders(message.subject)}}/>
                          {!isMobile && this.renderMessageRecipientsContainer()}
                      </Group>
                      <Group wrap="nowrap">
                          {!isMobile && this.renderReplyAndForwardButton()}
                      </Group>
                    </Group>
                </Stack>
            </Group>
            <Stack gap={0} className='message-detail-body' id='message-body' style={{background: 'white', height: '500px', padding: '30px 20px', overflow: 'scroll', borderRadius: '4px', border: '1px solid rgba(218, 218, 229, 1)'}} dangerouslySetInnerHTML={{__html: this.replaceValuesWithPlaceHolders(message.body)}} />
          </Stack>
          {openPreviewModal &&
          <MessagePostviewModal
          open={openPreviewModal}
          toggle={()=> this.setState({openPreviewModal: false})}
          isMobile={isMobile}
          allRecipients={message.recipients}
          messageData={message}
          senderAddress={(!accountData.addressCompany || !accountData.addressStreet || !accountData.addressZipCode || !accountData.addressCity) ? <span style={{color: '#dc3545', fontWeight: '500'}}>Absenderadresse unvollständig</span> : ` ${accountData.addressCompany+','} ${accountData.addressStreet+','} ${accountData.addressZipCode} ${accountData.addressCity}`}
          senderEmail={accountData.companyEmail}
          billingPeriod={null}
          selectedRecipient={selectedRecipient}
          selectedTenantId={selectedTenantId}
          />}
          {openSelectMessageRecipientToPrintModal &&
          <SelectMessageRecipientToPrint
          recipients={message.recipients}
          open={openSelectMessageRecipientToPrintModal}
          onPrint={(selectedRecipient)=> {
            let newWindow = window.open('/messagingPdf', "_blank");
            newWindow.message = message;
            newWindow.recipientId = selectedRecipient;
            this.setState({openSelectMessageRecipientToPrintModal: false});
          }}
          toggle={()=> this.setState({openSelectMessageRecipientToPrintModal: false})}/>}
          {openBulkMessageDownloadModal &&
          <BulkDownloadForMessageModal
          open={openBulkMessageDownloadModal}
          multipleTenants={[]}
          toggle={()=> this.setState({openBulkMessageDownloadModal: false, selectedMessageForBulkDownload: null})}
          allRecipients={selectedMessageForBulkDownload?.recipients}
          messageData={selectedMessageForBulkDownload}
          senderAddress={''}
          senderEmail={''}
          billingPeriod={''}
          isMobile={isMobile}
          postMessageDownload={true}
          />}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
      currentDataId: state.UtilityBillingReducer.currentBillingId,
      propertySelected: state.generalReducer.property,
      rentalUnits: state.tenantDataReducer.rentalUnits,
      currentSubscription: state.generalReducer.currentSubscription,
      accountData: state.generalReducer.accountData,
      profile: state.generalReducer.profile,
      profileData: state.generalReducer.profile
  };
};
export default connect(mapStateToProps)(MessageDetail);
